module.exports = __webpack_public_path__ + "img/lucklist_img1.93ea9135.png";